import React from "react";

export const GarlandLights: React.FC = () => {
  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 flex h-10 items-center justify-center">
      <div className="flex gap-2">
        <span className="h-2 w-2 rounded-full bg-red-400 shadow-[0_0_6px_rgba(248,113,113,0.9)]" />
        <span className="h-2 w-2 rounded-full bg-green-400 shadow-[0_0_6px_rgba(74,222,128,0.9)]" />
        <span className="h-2 w-2 rounded-full bg-yellow-300 shadow-[0_0_6px_rgba(253,224,71,0.9)]" />
        <span className="h-2 w-2 rounded-full bg-sky-400 shadow-[0_0_6px_rgba(56,189,248,0.9)]" />
      </div>
    </div>
  );
};

export default GarlandLights;

